import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import WishlistCard from "../../components/Home/WishlistCard/WishlistCard";
import SearchNav from "../../components/Home/SearchNav/SearchNav";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import SearchInput from "../../components/Home/SearchInput/SearchInput";

function Wishlist() {
  const [wishItems, setWishItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Recalculate total price whenever wishItems changes
  useEffect(() => {
    const calculateTotal = () => {
      const total = wishItems.reduce(
        (sum, item) => sum + item.price_per_item,
        0 // Initial value for sum
      );
      setTotalPrice(total);
    };

    calculateTotal();
  }, [wishItems]); // Dependency array to re-run whenever wishItems changes

  useEffect(() => {
    const getWishlist = async () => {
      const token = localStorage.getItem("token");
      let sessionId = localStorage.getItem("sessionid");

      

      try {
        const response = await USER_URL.get(`/products/wishlist/`);

        setLoading(false);
        setWishItems(response.data.items);
        console.log(response.data.items);
      } catch (error) {
        setLoading(false);
        setError("Error fetching wishlist items. Please try again later.");
        console.error("Error fetching wishlist items:", error);
      }
    };

    getWishlist();
  }, []);

  const fetchData = async (url, setter) => {
    try {
      const response = await axios.get(url);
      console.log(url, response);
      const data = response.data.Data || response.data.data;
      if (data) {
        setter(data);
      }
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
      const errorMessage = error.response?.data?.message || "Failed to fetch data";
      console.log("Fetch data error message:", errorMessage);
    }
  };

  useEffect(() => {
    fetchData(`${BASE_URL}/products/trending/`, setTrendingProducts);
  }, []);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };

  // Filter the wishlist items based on searchQuery
  const filteredWishItems = wishItems.filter(item =>
    item.product_name.toLowerCase().includes(searchQuery)
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner-border animate-spin border-4 rounded-full w-16 h-16 border-blue-500 border-t-transparent"></div>
        <p className="ml-4">Loading wishlist...</p>
      </div>
    );
  }

  return (
    <>

      <div className="container mx-auto px-4 sm:px-2 py-4">
        {error && (
          <div className="bg-red-500 text-white p-4 rounded-md mb-4 text-sm sm:text-base">
            {error}
          </div>
        )}
        <SearchInput
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search product..."
          head="Wishlist"
        />

        <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
          {/* Left Section: Wishlist Items */}
          <div className="col-span-1 lg:col-span-5">
            {filteredWishItems.length === 0 ? (
              <div className="text-center text-gray-500 text-sm sm:text-base">
                <p>No items found in your wishlist.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2  gap-6">
                {filteredWishItems.map((product, index) => (
                  <WishlistCard
                    key={product.product_id}
                    product={product}
                    row={Math.floor(index / 2)}
                    col={index % 2}
                    setWishlist={setWishItems}
                  />
                ))}
              </div>
            )}

            {filteredWishItems.length > 0 && (
              <div className="mt-8 bg-gray-100 p-4 rounded-lg text-right text-sm sm:text-base lg:text-lg">
                <p className="font-semibold">
                  Total Price: {filteredWishItems[0].currency_symbol}{totalPrice.toFixed(2)}
                </p>
              </div>
            )}
          </div>

          {/* Right Section: Trending Products */}
          <div className="col-span-1">
            <MyOrderProductCard
              products={trendingProducts}
              title="Trending Products"
              layout="vertical-3-scroll"
            />
          </div>
        </div>
      </div>
    </>
  );

}

export default Wishlist;
